import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconNotes: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.2938 3.14062L21.6187 2.46563L21.6094 2.45625C21.4641 2.32969 21.2719 2.25 21.0703 2.25C20.8641 2.25 20.6719 2.32969 20.5266 2.46094L19.9969 2.99531C19.9266 3.07031 19.9266 3.1875 19.9969 3.25781L20.4844 3.74531L21.5016 4.7625C21.5766 4.8375 21.6937 4.8375 21.7687 4.7625L22.2984 4.23281C22.4297 4.0875 22.5047 3.9 22.5047 3.68906C22.5 3.48281 22.425 3.28594 22.2938 3.14062ZM18.9516 4.03125L9.48281 13.5C9.4125 13.5703 9.375 13.6641 9.375 13.7625V15.0047C9.375 15.2109 9.54375 15.375 9.74531 15.375H10.9781C11.0766 15.375 11.175 15.3375 11.2453 15.2672L20.7188 5.79844C20.8641 5.65313 20.8641 5.41875 20.7188 5.27344L19.4766 4.03125C19.3312 3.88594 19.0969 3.88594 18.9516 4.03125ZM11.1891 16.2516C11.3859 16.2516 11.5781 16.1719 11.7188 16.0312L11.7563 15.9937L18.6844 9.075C18.8016 8.95781 19.0031 9.0375 19.0031 9.20625V19.0031C19.0031 20.5219 17.7703 21.7547 16.2516 21.7547H4.25156C2.73281 21.7547 1.5 20.5219 1.5 19.0031V8.50313C1.5 6.98438 2.73281 5.75156 4.25156 5.75156H15.5437C15.7078 5.75156 15.7922 5.95312 15.675 6.07031L8.75625 12.9891L8.71875 13.0266C8.57812 13.1672 8.49844 13.3594 8.49844 13.5562V15.5016C8.49844 15.9141 8.83594 16.2516 9.24844 16.2516H11.1891Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconNotes;
